import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const [favorites, setFavorites] = useState({});
  const carouselRef = useRef(null);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handlePrevClick = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    }
  };

  const handleNextClick = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    }
  };

  const toggleFavorite = (productId) => {
    setFavorites((prev) => ({
      ...prev,
      [productId]: !prev[productId],
    }));
  };

  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main>
        {/* 1 */}
        <div className="main_box1">
          <Link onClick={toTop} to="/shop">
            <img alt="" src="/main/main1.jpeg" />
          </Link>
        </div>

        {/* 2 - Best Sellers */}
        <div className="best-sellers">
          <h2 className="best-sellers__title">Best Sellers</h2>

          <div className="best-sellers__carousel-container">
            <button
              className="best-sellers__nav-button best-sellers__nav-button--prev"
              onClick={handlePrevClick}
              aria-label="Previous"
            >
              <i className="fas fa-chevron-left"></i>
            </button>

            <div className="best-sellers__carousel" ref={carouselRef}>
              {productData.slice(0, 10).map((product) => (
                <div key={product.id} className="best-sellers__product-card">
                  <div className="best-sellers__product-image">
                    <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                      <img src={product.images[0]} alt={product.name} />
                    </Link>
                    <button
                      className={`best-sellers__favorite-btn ${
                        favorites[product.id] ? "active" : ""
                      }`}
                      onClick={() => toggleFavorite(product.id)}
                      aria-label="Add to favorites"
                    >
                      <i
                        className={
                          favorites[product.id]
                            ? "fas fa-heart"
                            : "far fa-heart"
                        }
                      ></i>
                    </button>
                  </div>
                  <div className="best-sellers__product-info">
                    <div className="best-sellers__brand">{product.country}</div>
                    <h3 className="best-sellers__product-name">
                      <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                        {product.name}
                      </Link>
                    </h3>
                    <div className="best-sellers__price">${product.price}</div>
                  </div>
                </div>
              ))}
            </div>

            <button
              className="best-sellers__nav-button best-sellers__nav-button--next"
              onClick={handleNextClick}
              aria-label="Next"
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>

        {/* 3 - Our Story */}
        <div className="our-story-section">
          {/* Top Banner */}
          <div className="our-story__banner">
            <h2 className="our-story__banner-title">
              Discover Your Personalized Path to Wellness.
            </h2>
            <p className="our-story__banner-subtitle">
              11,000+ Quality Products, Curated for Your Everyday Joy!
            </p>
            <div className="our-story__banner-divider"></div>
          </div>

          {/* Main Content */}
          <div className="our-story__content">
            <div className="our-story__image-left">
              <img
                src="/main/main2-1.jpeg"
                alt="Historic Merz Bros Apothecary"
              />
            </div>

            <div className="our-story__text">
              <h2 className="our-story__title">Our Story</h2>
              <p className="our-story__paragraph">
                In 2025 we're celebrating the 150th anniversary of our brick and
                mortar store, Merz Apothecary!
              </p>
              <p className="our-story__paragraph">
                Founded in 1875 as an independent pharmacy in Chicago, Merz
                Apothecary was a thriving community hub for neighbors looking
                for natural and trusted wellness solutions — many of which were
                imported remedies from their home countries in Europe.
              </p>
              <p className="our-story__paragraph">
                Today, we're known as a destination for wellness, beauty,
                fragrance and personal care finds from around the world.
                Sadiemall is the online extension of Merz Apothecary. When you
                choose Sadiemall, you gain access to our unique history and
                years of dedicated health and wellness expertise, no matter
                where you are.
              </p>
              <p className="our-story__paragraph">
                We're proud to carry an assortment of products that help
                customers around the world feel their best — physically,
                mentally, and emotionally.
              </p>
              <button className="our-story__button">LEARN MORE</button>
            </div>

            <div className="our-story__image-right">
              <img
                src="/main/main2-2.jpeg"
                alt="Modern Merz Apothecary Store"
              />
            </div>
          </div>

          {/* Bottom Features Scroll */}
          <div className="our-story__features">
            <div className="our-story__features-scroll">
              <div className="our-story__feature">
                <i className="fas fa-diamond"></i>
                <span>Authentic Solutions</span>
              </div>
              <div className="our-story__feature">
                <i className="fas fa-diamond"></i>
                <span>Independent & Family-Owned</span>
              </div>
              <div className="our-story__feature">
                <i className="fas fa-diamond"></i>
                <span>Since 1875</span>
              </div>
              <div className="our-story__feature">
                <i className="fas fa-diamond"></i>
                <span>Real Experts</span>
              </div>
              <div className="our-story__feature">
                <i className="fas fa-diamond"></i>
                <span>Authentic Solutions</span>
              </div>
              <div className="our-story__feature">
                <i className="fas fa-diamond"></i>
                <span>Independent & Family-Owned</span>
              </div>
            </div>
          </div>
        </div>

        {/* 4 - Shop By Category */}
        <div className="shop-category">
          <h2 className="shop-category__title">Shop By Category</h2>

          <div className="shop-category__grid">
            {/* Row 1 */}
            <Link to="/shop" onClick={toTop} className="shop-category__card">
              <div className="shop-category__image">
                <img src="/main/main3-1.jpeg" alt="Best Sellers" />
              </div>
              <h3 className="shop-category__name">Best Sellers</h3>
            </Link>

            <Link to="/shop" onClick={toTop} className="shop-category__card">
              <div className="shop-category__image">
                <img src="/main/main3-2.jpeg" alt="German Classics" />
              </div>
              <h3 className="shop-category__name">German Classics</h3>
            </Link>

            <Link to="/shop" onClick={toTop} className="shop-category__card">
              <div className="shop-category__image">
                <img src="/main/main3-3.png" alt="Bath & Body" />
              </div>
              <h3 className="shop-category__name">Bath & Body</h3>
            </Link>

            <Link to="/shop" onClick={toTop} className="shop-category__card">
              <div className="shop-category__image">
                <img src="/main/main3-4.jpeg" alt="Skincare" />
              </div>
              <h3 className="shop-category__name">Skincare</h3>
            </Link>

            <Link to="/shop" onClick={toTop} className="shop-category__card">
              <div className="shop-category__image">
                <img src="/main/main3-5.jpeg" alt="Grooming" />
              </div>
              <h3 className="shop-category__name">Grooming</h3>
            </Link>

            {/* Row 2 */}
            <Link to="/shop" onClick={toTop} className="shop-category__card">
              <div className="shop-category__image">
                <img src="/main/main3-6.jpeg" alt="Wellness" />
              </div>
              <h3 className="shop-category__name">Wellness</h3>
            </Link>

            <Link to="/shop" onClick={toTop} className="shop-category__card">
              <div className="shop-category__image">
                <img src="/main/main3-7.jpeg" alt="Fragrance" />
              </div>
              <h3 className="shop-category__name">Fragrance</h3>
            </Link>

            <Link to="/shop" onClick={toTop} className="shop-category__card">
              <div className="shop-category__image">
                <img src="/main/main3-8.jpeg" alt="Home Fragrance" />
              </div>
              <h3 className="shop-category__name">Home Fragrance</h3>
            </Link>

            <Link to="/shop" onClick={toTop} className="shop-category__card">
              <div className="shop-category__image">
                <img src="/main/main3-9.jpeg" alt="All Brands" />
              </div>
              <h3 className="shop-category__name">All Brands</h3>
            </Link>

            <Link to="/shop" onClick={toTop} className="shop-category__card">
              <div className="shop-category__image">
                <img src="/main/main3-10.jpeg" alt="Sale" />
              </div>
              <h3 className="shop-category__name">Sale</h3>
            </Link>
          </div>
        </div>

        {/* 5 - Video Section */}
        <div className="video-section">
          <div className="video-section__content">
            <div className="video-section__text">
              <h2 className="video-section__title">
                Take A Look Inside Our Historic Apothecary
              </h2>

              <div className="video-section__channel">
                <div className="video-section__logo">S</div>
                <div className="video-section__info">
                  <div className="video-section__name">Sadiemall</div>
                  <div className="video-section__subscribers">
                    5.61K subscribers
                  </div>
                </div>
              </div>
            </div>

            <div className="video-section__video">
              <div className="video-section__video-wrapper">
                <video src="/main/main4.mp4" autoPlay muted loop />
              </div>
            </div>
          </div>
        </div>

        {/* 6 - As Seen In */}
        <div className="staff-picks">
          <div className="staff-picks__header">
            <div className="staff-picks__image">
              <img src="/main/main5.jpeg" alt="Merz Apothecary Staff" />
            </div>
            <div className="staff-picks__intro">
              <h2 className="staff-picks__title">Staff Picks</h2>
              <p className="staff-picks__subtitle">
                We use our expertise to create a modern apothecary experience.
              </p>
              <p className="staff-picks__description">
                Here at Sadiemall and Merz Apothecary, we strive to offer the
                world's best natural and unique products for total wellbeing.
                Just like our customers, the Sadiemall team is passionate about
                trying the latest products and we are thrilled to share some of
                our favorites with you!
              </p>
            </div>
          </div>

          <div className="staff-picks__products">
            {productData.slice(10, 14).map((product) => (
              <div key={product.id} className="staff-picks__product-card">
                <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                  <div className="staff-picks__product-image">
                    <img src={product.images[0]} alt={product.name} />
                  </div>
                  <div className="staff-picks__product-info">
                    <div className="staff-picks__brand">{product.country}</div>
                    <h3 className="staff-picks__product-name">
                      {product.name}
                    </h3>
                    <div className="staff-picks__price">${product.price}</div>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          <div className="staff-picks__button-wrapper">
            <Link to="/shop" onClick={toTop}>
              <button className="staff-picks__button">
                EXPLORE STAFF PICKS
              </button>
            </Link>
          </div>
        </div>

        {/* 7 - Ways To Save */}
        <div className="ways-to-save">
          <div className="ways-to-save__header">
            <h2 className="ways-to-save__title">Ways To Save At Sadiemall</h2>
            <p className="ways-to-save__subtitle">
              Sign up for our special promotions and unlock exclusive deals when
              you become a rewards member, activate subscriptions or refer a
              friend!
            </p>
          </div>

          <div className="ways-to-save__cards">
            {/* Rewards Card */}
            <div className="ways-to-save__card">
              <div className="ways-to-save__card-image">
                <img src="/main/main6-1.jpeg" alt="Rewards Program" />
              </div>
              <div className="ways-to-save__card-content">
                <h3 className="ways-to-save__card-title">Rewards</h3>
                <p className="ways-to-save__card-description">
                  Join Apothecary Rewards to earn points with every purchase and
                  unlock exclusive, members-only offers.
                </p>
              </div>
            </div>

            {/* Subscribe & Save Card */}
            <div className="ways-to-save__card">
              <div className="ways-to-save__card-image">
                <img src="/main/main6-2.jpeg" alt="Subscribe & Save" />
              </div>
              <div className="ways-to-save__card-content">
                <h3 className="ways-to-save__card-title">Subscribe & Save</h3>
                <p className="ways-to-save__card-description">
                  Save up to 5% when you subscribe to recurring orders of your
                  favorite daily essentials.
                </p>
              </div>
            </div>

            {/* Refer A Friend Card */}
            <div className="ways-to-save__card">
              <div className="ways-to-save__card-image">
                <img src="/main/main6-3.jpeg" alt="Refer A Friend" />
              </div>
              <div className="ways-to-save__card-content">
                <h3 className="ways-to-save__card-title">Refer A Friend</h3>
                <p className="ways-to-save__card-description">
                  Introduce a friend to Sadiemall to give them $10 off their
                  first order and your next one!
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 8 - Special Offers */}
        <div className="special-offers">
          <div className="special-offers__content">
            <div className="special-offers__text">
              <h2 className="special-offers__title">Special Offers</h2>
              <p className="special-offers__description">
                Discover new brands with our rotating selection of special trial
                sized gifts!
              </p>
              <Link to="/shop" onClick={toTop}>
                <button className="special-offers__button">
                  EXPLORE SPECIAL OFFERS
                </button>
              </Link>
            </div>
            <div className="special-offers__image">
              <img src="/main/main7.png" alt="Special Offers" />
            </div>
          </div>
        </div>

        {/* 9 - Customer Reviews */}
        <div className="customer-reviews">
          <h2 className="customer-reviews__title">Hear From Our Customers</h2>

          <div className="customer-reviews__rating">
            <div className="customer-reviews__stars">
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
            </div>
            <span className="customer-reviews__count">22691 reviews</span>
          </div>

          <div className="customer-reviews__carousel-container">
            <div className="customer-reviews__carousel">
              {/* Review 1 */}
              <div className="customer-reviews__card">
                <div className="customer-reviews__card-header">
                  <div className="customer-reviews__reviewer">
                    <i className="fas fa-user-circle"></i>
                    <span className="customer-reviews__name">
                      Verified Buyer
                    </span>
                  </div>
                  <span className="customer-reviews__date">10/10/25</span>
                </div>
                <div className="customer-reviews__card-stars">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
                <h3 className="customer-reviews__review-title">
                  Excellent product. I use on
                </h3>
                <p className="customer-reviews__review-text">
                  product. I use on my lips as well as under my eyes as a
                  concealer. Love that there is no fragrance added.
                </p>
                <div className="customer-reviews__product">
                  <div className="customer-reviews__product-info">
                    <p className="customer-reviews__product-name">
                      Weleda Wild Carrot Nourishing Eye Balm (0.5 fl oz)
                      #10076512
                    </p>
                  </div>
                </div>
              </div>

              {/* Review 2 */}
              <div className="customer-reviews__card">
                <div className="customer-reviews__card-header">
                  <div className="customer-reviews__reviewer">
                    <span className="customer-reviews__name">James M.</span>
                    <i className="fas fa-check-circle"></i>
                    <span className="customer-reviews__verified">
                      Verified Buyer
                    </span>
                  </div>
                  <span className="customer-reviews__date">10/10/25</span>
                </div>
                <div className="customer-reviews__card-stars">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
                <h3 className="customer-reviews__review-title">
                  The Smell of Scotland!
                </h3>
                <p className="customer-reviews__review-text">
                  My favorite scent from Caledonia!
                </p>
                <div className="customer-reviews__product">
                  <div className="customer-reviews__product-info">
                    <p className="customer-reviews__product-name">
                      Castle Forbes Gentlemen's Cologne EDP (100 ml) #10086619
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 10 - Visit Us */}
        <div className="visit-us">
          <div className="visit-us__content">
            <div className="visit-us__image">
              <img src="/main/main8.jpeg" alt="Merz Apothecary Store" />
            </div>
            <div className="visit-us__text">
              <h2 className="visit-us__title">Visit Us</h2>
              <div className="visit-us__info">
                <p className="visit-us__name">Merz Apothecary</p>
                <p className="visit-us__address">4716 N. Lincoln Avenue</p>
                <p className="visit-us__city">Chicago, IL 60625</p>
                <p className="visit-us__hours">Mon - Sat 10 AM - 6 PM</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </body>
  );
}

export default Main;
